import { useQuery } from "convex/react";
import { api } from "../convex/_generated/api";

/**
 * Runtime toggle sourced from Convex.
 * Defaults to `false` while loading and when missing, so the UI stays safe-by-default.
 */
export function useSpeedRailzMapPromoUiEnabled() {
  const isEnabled = useQuery(api.featureFlags.getSpeedRailzMapPromoUiEnabled);
  return isEnabled ?? false;
}
